import { useContext } from 'react';
import { MobXProviderContext } from 'mobx-react';
import { IServerNotificationItem } from '../../interfaces';

export function useUiServerNotificationsIsShowRead(): boolean {
    return useContext(MobXProviderContext).RootStore.alarmsStore.isShowServerNotificationsRead;
}

export function useUiServerNotificationsStatus(): number {
    return useContext(MobXProviderContext).RootStore.alarmsStore.isConnectServerNotifications;
}

export function useUiServerNotifications(isRead: boolean): IServerNotificationItem[] {
    const { serverNotificationsRead, serverNotificationsUnRead } =
        useContext(MobXProviderContext).RootStore.alarmsStore;
    return isRead ? serverNotificationsRead : serverNotificationsUnRead;
}

export function useUiServerNotificationsList(): IServerNotificationItem[] {
    return useContext(MobXProviderContext).RootStore.alarmsStore.serverNotificationsList;
}
export function useUiServerNotificationsAllCount(): number {
    return useContext(MobXProviderContext).RootStore.alarmsStore.serverNotificationsAllCount;
}

export function useUiServerNotificationsCount(): { countRead: number; countUnRead: number } {
    const { serverNotificationsReadCount, serverNotificationsUnReadCount } =
        useContext(MobXProviderContext).RootStore.alarmsStore;

    return { countRead: serverNotificationsReadCount, countUnRead: serverNotificationsUnReadCount };
}

export function useIsPopupOpen(): boolean {
    return useContext(MobXProviderContext).RootStore.alarmsStore.isPopupOpen;
}

export function useAlarmsShowCount(): number {
    return useContext(MobXProviderContext).RootStore.alarmsStore.showCount;
}
